import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const okendoMarketingSettings = defineIntegrationSettings({
  fields: {
    okendoUserId: z.string().trim().min(1, "Okendo Subscriber ID is required."),
  },
  secrets: { apiKey: z.string().trim().min(1, "Okendo API key is required.") },
  connectOnly: {},
  computed: { enabled: z.boolean() },
});
